export const cardLock = {
    defaultLockReason: undefined,
    /** Displays no fee info if value is false */
    hideInfoMessage: false,
    specificLockInfo: 'cards.shared.settings.reissue.lock.noFeeInfo',
    showDescription: true,
};
